import { useState, useEffect } from 'react';
import { FiArrowUp } from 'react-icons/fi';

export const BackToTop: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-30 bg-primary-green hover:bg-primary-lightgreen text-black p-4 rounded-full shadow-lg transition-all duration-200 hover:scale-110"
      aria-label="Back to top"
    >
      <FiArrowUp size={24} />
    </button>
  );
};

